module.exports = {"430725001":"漳江街道办","430725002":"浔阳街道办","430725101":"陬市镇","430725102":"盘塘镇","430725103":"热市镇","430725104":"黄石镇","430725105":"漆河镇","430725106":"理公港镇","430725107":"观音寺镇","430725108":"龙潭镇","430725109":"三阳港镇","430725110":"剪市镇","430725111":"茶庵铺镇","430725112":"西安镇","430725113":"沙坪镇","430725114":"桃花源镇","430725115":"架桥镇","430725116":"马鬃岭镇","430725117":"夷望溪镇","430725118":"双溪口镇","430725119":"九溪镇","430725120":"牛车河镇","430725121":"杨溪桥镇","430725122":"郑家驿镇","430725123":"木塘垸镇","430725200":"青林回族维吾尔族乡","430725202":"枫树维吾尔族回族乡","430725212":"佘家坪乡","430725216":"泥窝潭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430725.json
// module id = 1876
// module chunks = 0